import { render } from "./ReportToEmployeeAutocomplete.vue?vue&type=template&id=4b25c8c2"
import script from "./ReportToEmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportToEmployeeAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__